<div class="not-found-header">
    <h4>
        Please note that you are unable to access your account at this time. We apologize for this inconvenience and
        thank you for your patience. Please contact us at <a
            href='mailto:PreventionFeedback@ontario.ca'>PreventionFeedback&#64;ontario.ca</a> with any questions you may
        have
        as we work to restore your account.
    </h4>
    <br>
</div>
<br>
<div class="not-found-header">
    <h4>
        Veuillez noter que votre compte est actuellement inaccessible. Nous nous excusons pour ce désagrément et vous
        remercions de votre patience. Pour toute question, veuillez nous écrire à <a
            href='mailto:PreventionFeedback@ontario.ca'>PreventionFeedback&#64;ontario.ca</a>, le
        temps que nous rétablissons l’accès à votre compte.
    </h4>
</div>